import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMerchantPaymentOption } from '@/shared/model/merchant-payment-option.model';

const baseApiUrl = 'api/merchant-payment-options';
const baseSearchApiUrl = 'api/_search/merchant-payment-options?query=';

export default class MerchantPaymentOptionService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IMerchantPaymentOption> {
    return new Promise<IMerchantPaymentOption>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantPaymentOption): Promise<IMerchantPaymentOption> {
    return new Promise<IMerchantPaymentOption>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantPaymentOption): Promise<IMerchantPaymentOption> {
    return new Promise<IMerchantPaymentOption>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
